import {
    ActivityRequest,
    ActivityResponse,
} from '@sxm-de/dev-kits/microservices-sdk/types';
import { msPost } from '@sxm-de/dev-kits/microservices-sdk/utils';

export type ActivityFn = (
    payload: ActivityRequest,
) => Promise<ActivityResponse>;

export function initActivityFn({ baseUrl }: { baseUrl: string }): ActivityFn {
    return async (payload: ActivityRequest) => {
        const url = `${baseUrl}/billing/activity`;
        return await msPost<ActivityResponse>(url, payload);
    };
}
